module.exports = __webpack_public_path__ + "img/video-capture.8d07c065.svg";